import React from 'react';

import BaseDataTransformer from '../base-data-transformer/base-data-transformer';
import { GridCellExpand } from '../../../../components';

/*
maps plain chart data like this

{
  columns: ["id", "b", "c"],
  data: [
    { values: [1, "valX", 1001] },
    { values: [2, "valY", 1002] },
    { values: [3, "valZ", 1003] },
    { values: [4, "valQ", 1004]}
  ]
}

into this

{
  columns: [
    { field: 'id', headerName: 'id' },
    { field: 'b', headerName: 'b' },
    { field: 'c', headerName: 'c' },
  ],
  rows: [
    { id: 1, b: "valX", c: 1001 },
    { id: 2, b: "valY", c: 1002 },
    { id: 3, b: "valZ", c: 1003 },
    { id: 4, b: "valQ", c: 1004 },
  ]
}
*/

class DataGridDataTransformer extends BaseDataTransformer {
  renderCellExpand = params => (
    <GridCellExpand
      value={params.value ? params.value.toString() : ''}
      width={params.colDef.width}
    />
  )

  transform(data, options) {
    const { columns: columnOptions } = options || {};

    const columns = data.columns.map((c) => {
      const customColumnOption = columnOptions && columnOptions[c];

      return ({
        field: c,
        width: 150,
        renderCell: this.renderCellExpand,
        ...customColumnOption,
      });
    });

    const rows = data.data.map((d) => {
      const r = {};
      d.values.forEach((v, i) => {
        r[data.columns[i]] = v;
      });

      return r;
    });

    return ({ columns, rows });
  }
}

export default DataGridDataTransformer;
